import { useNode, useEditor } from "@craftjs/core";
import React from "react";
import GrigoraCSSRenderer from "./../css-render";
import { SeparatorSettings } from "./settings";
import icon from "./icon";
import { CMSSeparatorSettings } from "./cms-settings";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import CMSIcon from "./cms-icon";

export const Separator = (props) => {
  const {
    id,
    connectors: { connect, drag },
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const {} = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-separator": true,
      [`separator-${id}`]: id,
    },
    blockProps.className,
  );

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__Separator(id, props)}`}</style>
      <hr className="separator" />
    </div>
  );
};

// To Avoid Mangling in Production
Separator.displayName = "Separator";

Separator.craft = {
  name: "Separator",
  props: {},
  related: {
    settings: SeparatorSettings,
    CMSsettings: CMSSeparatorSettings,
    icon: icon,
    CMSIcon: CMSIcon,
    category: "layout",
    supports: [
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    keywords: ["Separator", "Seperator", "Line", "divider"],
  },
  custom: {
    name: "Separator",
    slug: "grigora/separator",
  },
};
